import {AuthenticationResult} from "@/angular/modules/vrm-core/login/login.service";

/**
 * @ngdoc Service
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .service('ResetPasswordService', ResetPasswordService);

    /**
     * @constructor
     * @ngInject
     */
    function ResetPasswordService(ApiService, vrmNotificationsService, vrmNotificationType, locale) {

        /* Public API */
        var service = {
            formModel: {
                password: "",
                password_confirm: "",
                password_reset_hash: "",
                mfa_token: "",
                language: locale.getLocale(),
            },
            updatePasswordRequest: updatePasswordRequest
        };

        let notificationId;

        /* Private */

        async function updatePasswordRequest() {
            vrmNotificationsService.remove(notificationId);

            try {
                const sentWithMfaCode = !!service.formModel.mfa_token;
                const { data } = await ApiService.auth('/updatepassword', service.formModel);

                if (data.password_changed) {
                    return AuthenticationResult.createSuccess();
                }

                // Reset password failed, check for MFA status
                if ('verification_mode' in data) {
                    const mfaMode = data.verification_mode;
                    const started = data.verification_sent;
                    if (sentWithMfaCode) {
                        // MFA code was sent, so the code was invalid
                        notifyError(locale.getString('resetpassword.twostep_code_wrong'));
                        return AuthenticationResult.createMfaFailure(mfaMode);
                    } else if (started) {
                        // MFA code not sent and sequence started
                        return AuthenticationResult.createMfaStarted(mfaMode);
                    } else {
                        // MFA code not sent, then third-party must have failed
                        notifyError(locale.getString('resetpassword.verification_failed'));
                        return AuthenticationResult.createMfaFailure(mfaMode);
                    }
                }

                // Login failed, check for a message from the api
                notifyError(data.message ? data.message : locale.getString('resetpassword.reset_failed'));
            } catch { } // ignored

            return AuthenticationResult.createFailure();
        }

        function notifyError(message) {
            notificationId = vrmNotificationsService.add({
                type: vrmNotificationType.ERROR,
                message,
            })
        }

        return service;
    }
})();
